import React, { useEffect } from 'react'
import Products from './Products'
import ShoppingCart from './ShoppingCart'
import { useSelector, useDispatch } from 'react-redux'
import API from './api.js'

const SolicitarCotacao = function SolicitarCotacao() {
  const dispatch = useDispatch()
  const productsTotal = useSelector((state) => state.products.total)

  useEffect(() => {
    async function getDataProducts() {
      if (productsTotal > 0) return

      await API.get(`produtos/count`)
        .then((res) => {
          dispatch({ type: 'SEARCH_COUNT_PRODUCTS', total: res.data })
        })
        .catch(function (error) {
          dispatch({ type: 'SEARCH_COUNT_PRODUCTS', total: 0 })
        })

      let config = {
        params: {
          // page: 1
        },
      }

      await API.get(`produtos`, config)
        .then((res) => {
          dispatch({ type: 'SET_PRODUCTS', produtos: res.data })
          dispatch({ type: 'END_FETCH_PRODUCTS' })
        })
        .catch(function (error) {
          dispatch({ type: 'END_FETCH_PRODUCTS' })
        })
    }

    dispatch({ type: 'START_FETCH_PRODUCTS' })
    getDataProducts()
  }, [])

  const categorias = useSelector((state) => {
    return [...state.products.categorias]
  })

  function renderCategoria(cat) {
    return (
      <div className='panel panel-default' key={cat.codCategoria}>
        <div
          className='panel-heading'
          style={{ cursor: 'pointer' }}
          onClick={() => dispatch({ type: 'FILTER_CATEGORY', categoria: cat })}
        >
          <h4 className='panel-title'>
            {cat.selecionado ? (
              <a>
                {cat.descricao}
                <span className='glyphicon glyphicon-ok' />
              </a>
            ) : (
              <a>{cat.descricao}</a>
            )}
          </h4>
        </div>
      </div>
    )
  }

  return (
    <div>
      <div
        className='row'
        style={{ display: 'flex', justifyContent: 'center' }}
      >
        <div className='col-sm-2'>
          <div className='category-products'>
            <h2 className='title text-center'>Categorias</h2>
            <div className='panel-group'>
              {' '}
              {categorias.map((cat) => renderCategoria(cat))}
            </div>
          </div>
        </div>

        <div className='col-sm-7'>
          <Products />
        </div>
        <div className='col-sm-2' style={{ padding: '0px' }}>
          <ShoppingCart />
        </div>
      </div>
    </div>
  )
}

export default SolicitarCotacao
